export default "__VITE_ASSET__FsEL3Bqx__"